import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';


const HRFaqSection = () => {
  const faqs = [
    {
      question: "When do I need HR Services?",
      answer: "HR services become essential when your business is growing, facing compliance challenges, or when management needs support with employee relations, recruitment, and policy development."
    },
    {
      question: "Is HR Consulting Expensive?",
      answer: "Our HR consulting is cost-effective and tailored to your needs. We offer flexible packages that are more affordable than hiring a full-time HR professional."
    },
    {
      question: "Does small business need compliance?",
      answer: "Absolutely. Even small businesses must comply with labor laws, workplace safety regulations, and employment standards to avoid legal risks and penalties."
    },
    {
      question: "HR recruiting vs recruiting company",
      answer: "HR recruiting integrates talent acquisition with your company culture and long-term strategy, while recruiting companies focus primarily on filling positions quickly."
    }
  ];

  const [openIndex, setOpenIndex] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
    const handleRecruit = () => navigate('/contact');

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div style={styles.container}>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;600;700;800&display=swap');
          
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(40px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes fadeInLeft {
            from {
              opacity: 0;
              transform: translateX(-40px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
          
          @keyframes fadeInRight {
            from {
              opacity: 0;
              transform: translateX(40px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
          
          @keyframes scaleIn {
            from {
              opacity: 0;
              transform: scale(0.9);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
          
          @keyframes float {
            0%, 100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-10px);
            }
          }
          
          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
            }
          }
          
          @keyframes slideDown {
            from {
              opacity: 0;
              max-height: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              max-height: 500px;
              transform: translateY(0);
            }
          }
          
          @keyframes blobMove {
            0%, 100% {
              transform: translate(0, 0) scale(1);
            }
            33% {
              transform: translate(30px, -30px) scale(1.1);
            }
            66% {
              transform: translate(-20px, 20px) scale(0.9);
            }
          }
          
          .stat-card:hover {
            transform: translateY(-5px) scale(1.05);
            box-shadow: 0 8px 30px rgba(198, 40, 40, 0.2);
          }
          
          .cta-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(198, 40, 40, 0.4);
          }
          
          .feature-item:hover .checkmark {
            animation: pulse 0.6s ease;
          }
        `}
      </style>
      
      <div style={{
        ...styles.wrapper,
        opacity: isVisible ? 1 : 0,
        animation: isVisible ? 'fadeInUp 0.8s ease forwards' : 'none'
      }}>
        {/* Left Content */}
        <div style={{
          ...styles.leftSection,
          animation: isVisible ? 'fadeInLeft 1s ease forwards 0.2s' : 'none',
          opacity: isVisible ? 1 : 0
        }}>
          <div style={{
            ...styles.badge,
            animation: isVisible ? 'scaleIn 0.6s ease forwards 0.4s' : 'none',
            opacity: isVisible ? 1 : 0
          }}>
            Expert HR Solutions
          </div>
          
          <h1 style={styles.mainTitle}>
            What does <span style={styles.highlight}>Humanex</span> do?
          </h1>

          <p style={styles.description}>
            We provide comprehensive HR solutions that empower businesses to focus on growth 
            while we handle the complexities of human resource management, compliance, and 
            talent acquisition.
          </p>

          <div style={styles.statsGrid}>
            {['500+', '15+', '98%'].map((stat, idx) => (
              <div 
                key={idx}
                className="stat-card"
                style={{
                  ...styles.statCard,
                  animation: isVisible ? `scaleIn 0.6s ease forwards ${0.6 + idx * 0.1}s` : 'none',
                  opacity: isVisible ? 1 : 0
                }}
              >
                <div style={styles.statNumber}>{stat}</div>
                <div style={styles.statLabel}>
                  {['Companies Served', 'Years Experience', 'Client Satisfaction'][idx]}
                </div>
              </div>
            ))}
          </div>

          <div style={styles.featuresGrid}>
            {[
              'HR Professional Support',
              'Recruitment & Talent Management',
              'Benefits & Payroll Administration',
              'Compliance & Policy Development'
            ].map((feature, idx) => (
              <div 
                key={idx}
                className="feature-item"
                style={{
                  ...styles.featureItem,
                  animation: isVisible ? `fadeInLeft 0.6s ease forwards ${0.9 + idx * 0.1}s` : 'none',
                  opacity: isVisible ? 1 : 0
                }}
              >
                {/* <span className="checkmark" style={styles.checkmark}></span> */}
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right Content - FAQ */}
        <div style={{
          ...styles.rightSection,
          animation: isVisible ? 'fadeInRight 1s ease forwards 0.3s' : 'none',
          opacity: isVisible ? 1 : 0
        }}>
          <div style={styles.faqContainer}>
            <div style={styles.faqHeader}>
              <h2 style={styles.faqTitle}>Frequently <span style={styles.highlight}>Asked</span> Questions</h2>
              <p style={styles.faqSubtitle}>Everything you need to know about our HR services</p>
            </div>

            <div style={styles.faqList}>
              {faqs.map((faq, index) => (
                <div 
                  key={index} 
                  style={{
                    ...styles.faqItem,
                    ...(openIndex === index ? styles.faqItemActive : {}),
                    animation: isVisible ? `fadeInUp 0.6s ease forwards ${1.1 + index * 0.1}s` : 'none',
                    opacity: isVisible ? 1 : 0
                  }}
                >
                  <button
                    onClick={() => toggleFAQ(index)}
                    style={styles.faqButton}
                  >
                    <span style={styles.faqQuestion}>{faq.question}</span>
                    <span style={{
                      ...styles.faqIcon,
                      transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)'
                    }}>
                      ▼
                    </span>
                  </button>
                  
                  {openIndex === index && (
                    <div style={{
                      ...styles.faqAnswer,
                      animation: 'slideDown 0.3s ease forwards'
                    }}>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div style={styles.ctaSection}>
              <p style={styles.ctaText}>Still have questions?</p>
              <button onClick={handleRecruit}
                className="cta-button"
                style={styles.ctaButton}
              >
                Contact Our Team →
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Background decorative elements */}
      <div style={{
        ...styles.bgBlob1,
        animation: 'blobMove 20s ease-in-out infinite'
      }}></div>
      <div style={{
        ...styles.bgBlob2,
        animation: 'blobMove 25s ease-in-out infinite reverse'
      }}></div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#ffffff',
    padding: '80px 20px',
    fontFamily: '"Raleway", sans-serif',
    position: 'relative',
    overflow: 'hidden',
  },
  wrapper: {
    maxWidth: '1300px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '80px',
    alignItems: 'start',
    position: 'relative',
    zIndex: 2,
  },
  leftSection: {
    paddingTop: '40px',
      textAlign: 'justify',

  },
  badge: {
    display: 'inline-block',
    padding: '10px 24px',
    background: 'linear-gradient(135deg, #c62828 )',
    color: 'white',
    borderRadius: '50px',
    fontSize: '13px',
    fontWeight: '700',
    marginBottom: '28px',
    letterSpacing: '1px',
    // boxShadow: '0 4px 15px rgba(198, 40, 40, 0.4)',
    fontFamily: '"Raleway", sans-serif',
    textTransform: 'uppercase',
    textAlign: 'justify',

  },
  mainTitle: {
    fontSize: '50px',
    fontWeight: '800',
    color: '#1e2330',
    lineHeight: '1.2',
    marginBottom: '28px',
    letterSpacing: '-1.5px',
    fontFamily: '"Raleway", sans-serif',
    textAlign: 'justify',
  },
  highlight: {
   color: '#c62828',
  },
  description: {
    fontSize: '17px',
    color: '#1e2330',
    lineHeight: '1.8',
    marginBottom: '45px',
    fontFamily: '"Raleway", sans-serif',
    fontWeight: '400',
    textAlign: 'justify',
    fontWeight: '500',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '10px',
    marginBottom: '45px',
  },
  statCard: {
    background: '#ffffff',
    padding: '28px 20px',
    borderRadius: '16px',
    textAlign: 'center',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: '2px solid #c62828',
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    cursor: 'pointer',
  },
  statNumber: {
    fontSize: '36px',
    fontWeight: '800',
    color: '#c62828',
    marginBottom: '8px',
    fontFamily: '"Raleway", sans-serif',
  },
  statLabel: {
    fontSize: '13px',
    color: '#1e2330',
    fontWeight: '600',
    fontFamily: '"Raleway", sans-serif',
    letterSpacing: '0.5px',
  },
  featuresGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '18px',
  },
  featureItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    fontSize: '14px',
    color: '#1e2330',
    fontFamily: '"Raleway", sans-serif',
    fontWeight: '600',
    transition: 'transform 0.3s ease',
    textAlign: 'justify',
    padding: '10px',
  },
  checkmark: {
    width: '26px',
    height: '26px',
    background: 'linear-gradient(135deg, #c62828 0%, #8b0000 100%)',
    color: 'white',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: 'bold',
    flexShrink: 0,
    boxShadow: '0 2px 8px rgba(198, 40, 40, 0.3)',
  },
  rightSection: {
    position: 'sticky',
    top: '100px',
     textAlign: 'justify',
  },
  faqContainer: {
    background: '#ffffff',
    borderRadius: '28px',
    padding: '45px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.12)',
    border: '2px solid #f5f5f5',
  },
  faqHeader: {
    marginBottom: '35px',
    textAlign: 'center',
  },
  faqTitle: {
    fontSize: '34px',
    fontWeight: '800',
    color: '#1e2330',
    marginBottom: '10px',
    fontFamily: '"Raleway", sans-serif',
    letterSpacing: '-0.5px',
     textAlign: 'justify',
  },
  faqSubtitle: {
    fontSize: '15px',
    color: '#1e2330',
    fontFamily: '"Raleway", sans-serif',
    fontWeight: '500',
     textAlign: 'justify',
  },
  faqList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    marginBottom: '35px',
     textAlign: 'justify',
  },
  faqItem: {
    background: '#fafafa',
    borderRadius: '14px',
    overflow: 'hidden',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    border: '2px solid transparent',
  },
  faqItemActive: {
    background: '#fff5f5',
    borderColor: '#c62828',
    boxShadow: '0 6px 20px rgba(198, 40, 40, 0.18)',
    transform: 'translateY(-2px)',
  },
  faqButton: {
    width: '100%',
    padding: '22px 24px',
    background: 'none',
    border: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    textAlign: 'left',
  },
  faqQuestion: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#1e2330',
    flex: 1,
    fontFamily: '"Raleway", sans-serif',
    letterSpacing: '0.2px',
  },
  faqIcon: {
    fontSize: '13px',
    color: '#c62828',
    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    fontWeight: 'bold',
  },
  faqAnswer: {
    padding: '0 24px 22px 24px',
    fontSize: '14px',
    color: '#666',
    lineHeight: '1.8',
    fontFamily: '"Raleway", sans-serif',
    fontWeight: '400',
  },
  ctaSection: {
    textAlign: 'center',
    paddingTop: '28px',
    borderTop: '2px solid #f0f0f0',
  },
  ctaText: {
    fontSize: '15px',
    color: '#666',
    marginBottom: '18px',
    fontFamily: '"Raleway", sans-serif',
    fontWeight: '600',
  },
  ctaButton: {
    padding: '16px 38px',
    background: 'linear-gradient(135deg, #c62828 0%, #8b0000 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '14px',
    fontSize: '15px',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 4px 15px rgba(198, 40, 40, 0.35)',
    fontFamily: '"Raleway", sans-serif',
    letterSpacing: '0.5px',
  },
  bgBlob1: {
    position: 'absolute',
    width: '600px',
    height: '600px',
    background: 'radial-gradient(circle, rgba(198, 40, 40, 0.1) 0%, transparent 70%)',
    borderRadius: '50%',
    top: '-150px',
    left: '-150px',
    filter: 'blur(100px)',
    zIndex: 1,
  },
  bgBlob2: {
    position: 'absolute',
    width: '700px',
    height: '700px',
    background: 'radial-gradient(circle, rgba(198, 40, 40, 0.08) 0%, transparent 70%)',
    borderRadius: '50%',
    bottom: '-200px',
    right: '-200px',
    filter: 'blur(120px)',
    zIndex: 1,
  },
};

// Add media query handling
const mediaQuery = window.matchMedia('(max-width: 992px)');
if (mediaQuery.matches) {
  styles.wrapper.gridTemplateColumns = '1fr';
  styles.wrapper.gap = '40px';
  styles.statsGrid.gridTemplateColumns = 'repeat(3, 1fr)';
  styles.featuresGrid.gridTemplateColumns = '1fr';
  styles.mainTitle.fontSize = '38px';
  styles.rightSection.position = 'relative';
  styles.rightSection.top = '0';
}

export default HRFaqSection;